import { render, staticRenderFns } from "./DisplaySingleUser.vue?vue&type=template&id=5280359d&scoped=true&"
import script from "./DisplaySingleUser.vue?vue&type=script&lang=js&"
export * from "./DisplaySingleUser.vue?vue&type=script&lang=js&"
import style0 from "./DisplaySingleUser.vue?vue&type=style&index=0&id=5280359d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5280359d",
  null
  
)

export default component.exports